<template>
  <ap-register :state="state" />
</template>

<script>
import ApRegister from "@/components/artek/ap-register";

export default {
  props: {
    state: {
      type: String,
      required: true
    }
  },
  components: {
    ApRegister
  }
};
</script>
